import { defineMessages } from 'react-intl';

export const footerTranslations = defineMessages({
  corporateInformation: {
    id: 'footer.corporateInformation',
    defaultMessage: 'Corporate Information',
    description: 'Corporate Information text in footer',
  },
  privacyNotice: {
    id: 'footer.privacyNotice',
    defaultMessage: 'Privacy Notice',
    description: 'Privacy Notice text in footer',
  },
  cookieNotice: {
    id: 'footer.cookieNotice',
    defaultMessage: 'Cookie Notice',
    description: 'Cookie Notice text in footer',
  },
  termsOfUse: {
    id: 'footer.termsOfUse',
    defaultMessage: 'Terms of Use',
    description: 'Terms of Use text in footer',
  },
  digitalId: {
    id: 'footer.digitalId',
    defaultMessage: 'Digital ID',
    description: 'Digital ID text in footer',
  },
  siemens: {
    id: 'footer.siemens',
    defaultMessage: '©{year} Siemens',
    description: 'Siemens text in footer',
  },
});
